import React from "react";
import { Modal } from "antd";

const KidsWorldPreviewModal: React.FC<{
  open: boolean;
  title?: string;
  vimeoId?: string;
  onClose: () => void;
}> = ({ open, title, vimeoId, onClose }) => (
  <Modal
    open={open}
    onCancel={onClose}
    footer={null}
    width={720}
    centered
    title={title || "Video"}
    destroyOnClose
    afterClose={onClose}
  >
    <div className="kw-preview">
      {vimeoId ? (
        <div className="kw-preview__player" style={{ position: "relative", paddingTop: "56.25%" }}>
          <iframe
            key={vimeoId}
            src={`https://player.vimeo.com/video/${vimeoId}`}
            title={`Vimeo ${vimeoId}`}
            style={{ position: "absolute", inset: 0, width: "100%", height: "100%", border: 0 }}
            allow="autoplay; fullscreen; picture-in-picture"
            allowFullScreen
          />
        </div>
      ) : (
        <div className="kw-preview__player">Player</div>
      )}
    </div>
  </Modal>
);

export default KidsWorldPreviewModal;
